/*********************** Custom JS for Boost AI Search & Discovery  ************************/
if (window.boostSDAppConfig) {
  window.boostSDAppConfig.integration = Object.assign(
    { wishlists: 'plus' },
    window.boostSDAppConfig.integration || {}
  )

  window.boostSDAppConfig.shop.money_format =
    '{{amount_with_comma_separator}} €'
  window.boostSDAppConfig.shop.money_format_with_currency =
    '{{amount_with_comma_separator}} €'
}
const isMobile = () => {
  let check = false
  ;(function (a) {
    if (
      /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
        a
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        a.substr(0, 4)
      )
    )
      check = true
  })(navigator.userAgent || navigator.vendor || window.opera)
  return check
}

let windowWidth = 0 // Initialize the windowWidth variable to store the width.
const _checkIsMobile = () => {
  if (!windowWidth) {
    // We don't want to re-calculate the width every time because it causes a style recalculation every time.
    // So we store it
    windowWidth = window.innerWidth

    // Calculate the width on resize
    window.addEventListener('resize', () => {
      windowWidth = window.innerWidth
    })
  }
  return windowWidth <= 768
}

// Check isCollectionPage
const isCollectionPage = () => {
  return window.location.pathname.includes('/collections')
}

const cardCTA = boostSDData?.card_CTA

// Adjust pagination
window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat(
  (registry) => {
    const apis = ['SearchAPI', 'FilterAPI']

    apis.forEach((api) => {
      registry.useModulePlugin(api, {
        name: 'Extra params filter in collection/search page',
        apply(builder) {
          const originalFetch = window.fetch
          window.fetch = async (...args) => {
            if (args?.[0]) {
              try {
                let url = new URL(args[0])
                if (url.host === 'services.mybcapps.com') {
                  url.searchParams.delete('locale')
                  url.searchParams.delete('country')
                  url.searchParams.delete('currency')
                  url.searchParams.delete('currency_rate')
                  args[0] = url.toString()
                }
              } catch (error) {
                console.log('error', error)
              }
            }

            const response = await originalFetch(...args)

            return response
          }

          builder.on('beforeMethodCall', 'get', (payload) => {
            if (cardCTA) {
              payload.args[1].limit = payload.args[1].limit - 1
            }
          })
        },
      })
    })
  }
)

const customBanner = {
  productListAfterRender: (componentRegistry) => {
    let preventReCallProductHandlesTheSame = []
    componentRegistry.useComponentPlugin('ProductList', {
      name: 'Product List After Render',
      enabled: true,
      apply: () => ({
        afterRender(element) {
          if (!isCollectionPage()) return
          try {
            // Start customization ---------------------------------------
            const helpersRef = element.getHelpers()
            // Function get all handles displayed in product list
            const productHandles = helpersRef.getProductHandles()
            // Check duplicate not call. prevent call multi the same value
            const isDuplicate =
              JSON.stringify(preventReCallProductHandlesTheSame) ===
              JSON.stringify(productHandles)
            preventReCallProductHandlesTheSame = productHandles

            if (productHandles?.length && !isDuplicate) {
              var elements = document.getElementsByClassName(
                'boost-sd__custom-card-CTA'
              )
              // Convert the HTMLCollection to an array for easier manipulation
              var elementsArray = Array.from(elements)
              // Remove each element
              elementsArray.forEach(function (element) {
                element.remove()
              })

              // Add general card
              if (cardCTA && cardCTA.cta_title) {
                insertCard(cardCTA)
              }
            }

            // move collection links
            const collectionLinks = document.querySelector("[data-collection-links]");
            if (collectionLinks) {
              // Remove collection links from its current position
              collectionLinks.remove();
              const collectionHeader = document.querySelector(".boost-sd__collection-header");
              if (collectionHeader) {
                collectionHeader.insertAdjacentElement('afterend', collectionLinks);
                collectionLinks.classList.add('flex');
                collectionLinks.classList.remove('hidden');
              }
            }
            // End customization ---------------------------------------
          } catch (err) {
            console.warn(err)
          }
        },
      }),
    })
  },
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  customBanner.productListAfterRender,
])

function compileCardTemplate(cardCTA, CTAMobile) {
  const {
    cta_title,
    cta_url,
    description,
    image,
    image_mobile,
    position,
    position_mobile,
    title,
  } = cardCTA
  const newElement = document.createElement(`${cta_url ? 'a' : 'div'}`)
  if (cta_url && cta_url != '') newElement.href = cta_url
  let className =
    'boost-sd__product-item boost-sd__product-item--no-border boost-sd__product-item-grid-view-layout boost-sd__custom-card-CTA'
  if (CTAMobile) {
    className += ' boost-sd__custom-card-CTA--mobile'
  } else {
    className += ' boost-sd__custom-card-CTA--desktop'
  }
  newElement.className = className
  if (CTAMobile) {
    newElement.innerHTML =
      `
        <div class="overflow-hidden rounded relative h-full flex flex-col justify-end p-4">
            <img class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 object-cover rounded w-full h-full" src="${image_mobile}" alt="${cta_title}">
            <div class="boost-sd-filter-product-item__promo--cta rounded p-6">
            <h4 class="mb-2 uppercase text-base lg:text-lg lg:leading-6 text-black">${title}</h4>
            <div class="text-grey-1 font-normal">${description}</div>` +
      `     <span class="button mt-4">${cta_title}</span>
            </div>
        </div>
        `
  } else {
    newElement.innerHTML =
      `
        <div class="overflow-hidden rounded relative h-full flex flex-col justify-end p-4">
            <img class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 object-cover rounded w-full h-full" src="${image}" alt="${cta_title}">
            <div class="boost-sd-filter-product-item__promo--cta rounded p-6">
            <h4 class="mb-2 uppercase text-base lg:text-lg lg:leading-6 text-black">${title}</h4>
            <div class="text-grey-1 font-normal">${description}</div>` +
      `     <span class="button mt-4">${cta_title}</span>
            </div>
        </div>
        `
  }
  let cardTemplate = newElement.outerHTML
  return cardTemplate
}

function insertCard(cardCTA) {
  const cardHTML = compileCardTemplate(cardCTA, false)
  const mobileCardHTML = compileCardTemplate(cardCTA, true)

  const container = document.querySelector('.boost-sd__product-list')

  // Get the existing div at the specified index (if it exists)
  let cardIndexDesktop = cardCTA.position
  let cardIndexMobile = cardCTA.position_mobile
  const existingDiv = container.children[cardIndexDesktop - 2]
  const existingDivMobile = container.children[cardIndexMobile - 2]
  const lastDiv = container.lastChild

  // Insert the new div before the existing div (if found), or append it at the end
  if (existingDiv) {
    existingDiv.insertAdjacentHTML('afterend', cardHTML)
  } else {
    lastDiv.insertAdjacentHTML('afterend', cardHTML)
  }

  if (existingDivMobile) {
    existingDivMobile.insertAdjacentHTML('afterend', mobileCardHTML)
  } else {
    lastDiv.insertAdjacentHTML('afterend', mobileCardHTML)
  }
}

function buildProgressBar(progressPercentage) {
  const progressBarContainer = document.createElement('div')
  progressBarContainer.className = 'boost-sd__progress-bar-container'

  const progressBar = document.createElement('div')
  progressBar.className = 'boost-sd__progress-bar'
  progressBar.style.width = progressPercentage + '%'

  progressBarContainer.appendChild(progressBar)
  return progressBarContainer
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin('PaginationLoadMore', {
      name: 'Modify Component',
      enabled: true,
      apply: () => {
        return {
          afterRender(element) {
            try {
              const loadMoreButtonContainer = document.querySelector(
                '.boost-sd__pagination-load-more-container-button'
              )
              let progressBarContainer =
                document.querySelector('.plp-progressbar')
              const productCountElement = document.querySelector(
                '.boost-sd__pagination-load-more-container-product-count .boost-sd__product-count'
              )
              if (productCountElement) {
                const productCountText = productCountElement.textContent
                const regex = /(\d+)\s+von\s+(\d+)\s+Produkten/i
                const matches = productCountText.match(regex)

                if (matches && matches.length === 3) {
                  const endProduct = parseInt(matches[1], 10)
                  const totalProducts = parseInt(matches[2], 10)
                  const currentDisplayedProducts = endProduct
                  const calcWidth =
                    (currentDisplayedProducts / totalProducts) * 100.0
                  if (!progressBarContainer) {
                    // Insert progress bar initially
                    productCountElement.insertAdjacentHTML(
                      'afterend',
                      `<div class="plp-progressbar"><div class="plp-progressbar-inner" style="width:${calcWidth}%;"></div></div> `
                    )
                  } else {
                    const progressBar = progressBarContainer.querySelector(
                      '.plp-progressbar-inner'
                    )
                    progressBar.style.setProperty(
                      'width',
                      `${calcWidth}%`,
                      'important'
                    )
                  }
                } else {
                  console.log('Error: Could not parse product count text.')
                }
              } else {
                console.log('Error: Could not find product count element.')
              }
            } catch (error) {
              console.log('Error in rendering/updating progress bar:', error)
            }
          },
        }
      },
    })
  },
])

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductItem', {
      name: 'Modify Product Item Element',
      enabled: true,
      apply: () => ({
        afterRender(element) {
          let elementHTML = element.getRootElm()
          let productData = element.getParams().props.product
          let productItem = document.querySelector(
            '.boost-sd__product-item[data-product-id="' + productData.id + '"]'
          )

          if (!productItem) {
            return
          }

          const variants = productData.variants
          // const options = productData.options_with_values
          // var variant_html = ''

          variants.forEach((variant) => {
            let variantTitle = variant.title
            if (variantTitle != 'Default Title') {
              let splitVariantTitle = splitString(variantTitle)
              let swatchElement = elementHTML.querySelector(
                '[for*="' + productData.id + '-' + splitVariantTitle + '-"]'
              )
              let variantBarcode = variant.barcode
              let swatchImage =
                '//de.handicraft.com/cdn/shop/files/' + variantBarcode + '.jpg'
              if (swatchElement) {
                swatchElement.style.backgroundImage =
                  "url('" + swatchImage + "')"

                if (!variant.available) {
                  swatchElement.classList.add('variant-oos')
                }
              }
            }
          })

          const moreVarDiv = document.createElement('div')
          const target = elementHTML.querySelector('.boost-sd__product-price')
          moreVarDiv.textContent = `+${variants.length} Varianten verfügbar`
          moreVarDiv.className = 'more-variants'

          if (target && target.parentNode && variants.length > 1) {
            target.parentNode.insertBefore(moreVarDiv, target)
          }
        },
      }),
    })
  },
])

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductPrice', {
      name: 'Modify Product Price Element',
      enabled: true,
      apply: () => ({
        afterRender(element) {
          let productData = element.getParams().props.data
          let productItem = document.querySelector(
            '.boost-sd__product-item[data-product-id="' + productData.id + '"]'
          )

          if (!productItem) {
            return
          }

          let price = parseFloat(productData.price_min).toFixed(2)
          let formattedPrice = new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR',
          }).format(price)
          let elementHTML = element
            .getRootElm()
            .querySelector('.boost-sd__format-currency span')

          if (elementHTML) {
            elementHTML.innerHTML = formattedPrice
          }
        },
      }),
    })
  },
])

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin('SearchProductItem', {
      name: 'Modify Instant Search Product Item Element',
      enabled: true,
      apply: () => ({
        afterRender(element) {
          let elementHTML = element.getRootElm()
          let productData = element.getParams().props.product
          let productItem = document.querySelector(
            '.boost-sd__suggestion-queries-item[data-id="' +
              productData.id +
              '"]'
          )

          if (!productItem) {
            return
          }

          if (productData.price_min != productData.price_max) {
            let span = document.createElement('span')
            let priceElement = elementHTML.querySelector(
              '.boost-sd__suggestion-queries-item-amount'
            )

            span.className = 'boost-sd__from-label'

            if (Shopify.locale == 'de') {
              span.innerHTML = 'ab'
            } else if (Shopify.locale == 'fr') {
              span.innerHTML = 'dès'
            }

            if (!elementHTML.querySelector('.boost-sd__from-label')) {
              priceElement?.prepend(span)
            }
          }

          let price = parseFloat(productData.price_min).toFixed(2)
          let formattedPrice = new Intl.NumberFormat('de-DE', {
            style: 'currency',
            currency: 'EUR',
          }).format(price)
          let currencyHTML = element
            .getRootElm()
            .querySelector('.boost-sd__format-currency span')

          if (currencyHTML) {
            currencyHTML.innerHTML = formattedPrice
          }
        },
      }),
    })
  },
])

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([
  (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductSwatchOption', {
      name: 'Modify Product Swatch Element',
      enabled: true,
      apply: () => ({
        afterRender(element) {
          let props = element.getParams().props
          let elementHTML = element.getRootElm()
          let productData = element.getParentElm().getParentElm().getParams()
            .props.data
          let productElement = element
            .getParentElm()
            .getParentElm()
            .getRootElm()
          let wishlistButton = productElement.querySelector(
            '.boost-sd__wishlist button'
          )

          let variantId = ''

          productData.variants.forEach((variant) => {
            if (variant.title == props.label) {
              variantId = variant.id
            }
          })

          elementHTML.addEventListener('click', function () {
            if (wishlistButton) {
              wishlistButton.setAttribute('data-variant-id', variantId)
              wishlistButton.dataset.variantId = variantId
              document.dispatchEvent(new CustomEvent('swym:collections-loaded'))
            }
          })
        },
      }),
    })
  },
])

function splitString(string) {
  return string.split(/\/|-/)[0]
}
